import { render, staticRenderFns } from "./DinnerMonthly.vue?vue&type=template&id=3bfaaaac&scoped=true&"
import script from "./DinnerMonthly.vue?vue&type=script&lang=js&"
export * from "./DinnerMonthly.vue?vue&type=script&lang=js&"
import style0 from "./DinnerMonthly.vue?vue&type=style&index=0&id=3bfaaaac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bfaaaac",
  null
  
)

export default component.exports